/**
 * 
 * @param {string} cpf 
 */
function validCPF(cpf) {
	if( typeof(cpf) !== 'string' ) {
		console.error( { 
			function: 'validCPF',
			message: `the informed value must be of type string and not a ( ${typeof(cpf)} )` 
		} )

		return null
	}

	if( cpf.length < 11 || cpf.length > 11 ) {
		console.error( { 
			function: 'validCPF',
			message: `the value entered must be 11 characters` 
		} )

		return null
	}

	return checksCPF(cpf)
}

function multipliesNumbers(number, index) {
	const array = [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]
	return number * array[index]
}

function stringForArray(string, numbreCaracter = string.length) {
	return string.split( '', numbreCaracter )
}

function arrayForString(array) {
	return array.join('')
}

function sumNumeros(accumulator, current) {
	return accumulator + current
}

function restOfDivision(number) {
	return number % 11
}

function validDigit(cpf, characterNumbers) {
	const arrayNumber = stringForArray(cpf, characterNumbers);

	const sumOfNumbers = arrayNumber
		.reverse()
		.map((number, index) => multipliesNumbers(number, index))
		.reduce((total, current) => sumNumeros(total, current));

	const Digit = restOfDivision(sumOfNumbers)

	if (Digit >= 10) {
		return 0
	}

	return Digit
}

/**
 * 
 * @param {string} cpf 
 */
function checksCPF(cpf) {
	if( cpf === "00000000000" || 
        cpf === "11111111111" || 
        cpf === "22222222222" || 
        cpf === "33333333333" || 
        cpf === "44444444444" || 
        cpf === "55555555555" || 
        cpf === "66666666666" || 
        cpf === "77777777777" || 
        cpf === "88888888888" || 
        cpf === "99999999999") {
        return false
	}

	const firstDigit = validDigit(cpf, 9)
	const lastDigit = validDigit(cpf, 10)
	
	let cpfInArray = stringForArray(cpf, 9)
	cpfInArray = [...cpfInArray, firstDigit, lastDigit]
	let cpfInString = arrayForString(cpfInArray)


	if(cpf === cpfInString) {
		return true
	} else {
		return false
	}

}

export const CPFIsValid = validCPF